import { IDeliveryCoordinates } from './models/deliveryCoordinates.interface';
import { MovPolygon } from './models/movPolygon';

export class PolygonHelpers {
  public static readonly DEFAULT_STANDARD_OFFSET = 0.01;
  public static readonly DEFAULT_EXTENDED_OFFSET = 0.02;

  public static readonly DEFAULT_MOV_OFFSET = 0.03;

  public static generateDefaultStandardPolygon(facilityCoordinates: IDeliveryCoordinates): IDeliveryCoordinates[] {
    return PolygonHelpers.generatePolygonAroundCentralPoint(
      facilityCoordinates.latitude,
      facilityCoordinates.longitude,
      PolygonHelpers.DEFAULT_STANDARD_OFFSET,
    );
  }

  public static generateDefaultExtendedPolygon(facilityCoordinates: IDeliveryCoordinates): IDeliveryCoordinates[] {
    return PolygonHelpers.generatePolygonAroundCentralPoint(
      facilityCoordinates.latitude,
      facilityCoordinates.longitude,
      PolygonHelpers.DEFAULT_EXTENDED_OFFSET,
    );
  }

  public static generateDefaultMovPolygon(facilityCoordinates: IDeliveryCoordinates): IDeliveryCoordinates[] {
    return PolygonHelpers.generatePolygonAroundCentralPoint(
      facilityCoordinates.latitude,
      facilityCoordinates.longitude,
      PolygonHelpers.DEFAULT_MOV_OFFSET,
    );
  }

  public static generatePolygonAroundCentralPoint(
    latitude: number,
    longitude: number,
    offset: number,
  ): IDeliveryCoordinates[] {
    return [
      new IDeliveryCoordinates(latitude + offset, longitude), // Point 1: North of the center
      new IDeliveryCoordinates(latitude, longitude + offset), // Point 2: East of the center
      new IDeliveryCoordinates(latitude - offset, longitude - offset), // Point 3: Southwest of the center
    ];
  }

  /** Eventually we will want these to be configurable by the user after MVP delivery */
  public static readonly DEFAULT_MINIMUM_ORDER_VALUE = 150;
  public static readonly DEFAULT_MENU_TYPE = 'Extended';

  public static createMovPolygon(
    name: string,
    coordinates: IDeliveryCoordinates[],
    options?: {
      minimumOrderValue?: number;
      menuType?: string;
    },
  ): MovPolygon {
    return {
      name,
      coordinates,
      minimumOrderValue: options?.minimumOrderValue ?? PolygonHelpers.DEFAULT_MINIMUM_ORDER_VALUE,
      menuType: options?.menuType ?? PolygonHelpers.DEFAULT_MENU_TYPE,
    };
  }
}
